import * as _ from 'lodash';
import { Reducer } from 'redux';
import {
  IUsersFetchAction,
  USER_BLOCK_SUCCESS,
  USER_DETAIL_FETCH_SUCCESS,
  USER_REMOVE_SUCCESS,
  USERS_ERROR,
  USERS_FETCH_SUCCESS,
} from '../actions/users';
import { IUsersState } from '../types/user';

export const initialState: IUsersState = {};

const reducer: Reducer<IUsersState> = (
  state: IUsersState = initialState,
  action: IUsersFetchAction
) => {
  switch (action.type) {
    case USERS_FETCH_SUCCESS:
      return { users: action.payload.users, meta: action.payload.meta };
    case USER_DETAIL_FETCH_SUCCESS:
      return { detail: action.payload.user };
    case USER_REMOVE_SUCCESS:
      return {
        users: _.map(state.users, u => {
          return u.id === action.payload.user.id ? action.payload.user : u;
        }),
      };
    case USER_BLOCK_SUCCESS:
      return {
        users: _.map(state.users, u => {
          return {
            ...u,
            enabled: u.id === action.payload.id ? !u.enabled : u.enabled,
          };
        }),
      };
    case USERS_ERROR:
      return {
        error: action.message,
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/users.ts